import React, { use, useEffect, useRef, useState } from "react";
import Pusher from "react-pusher";
import "./event-listing.scss";
import CountdownTimer from "../../components/CountdownTimer";
import Events from "../../components/Events/Events";
import { useDispatch, useSelector } from "react-redux";
import Attendees from "../../components/Events/Attendees";
import MeetingTable from "../../components/meeting-table/MeetingTable";
import { toast } from "react-toastify";
import { SiJitsi } from "react-icons/si";

// images
import AppleStore from "../../images/apple-store.png";
import GooglePlayStore from "../../images/google-playstore.png";
import MainContainer from "../../components/main-container/main-container.component";
import axios from "axios";
import clientConfig from "../../env";
import { updateBetaCredit } from "../../redux/user/user.actions";
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "../../components/modal/modal.components";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const initialEventData = {
  event_name: "",
  topic_description: "",
  event_date: "",
  event_time: "",
  event_type: "public",
  event_invites: "",
};

function EventListing() {
  const meetingTableRef = useRef(null);
  const joinTableConfirmationRef = useRef(null);
  const joinTableConfirmationClosebtnRef = useRef(null);

  const dispatch = useDispatch();

  const history = useHistory();

  const token = useSelector((state) => state.user.token);
  const userCredit = useSelector((state) => state.user.mycredits);
  const userId = useSelector((state) => state.user.userId);
  const firstName = useSelector((state) => state.user.firstName);
  const profile_picture = useSelector((state) => state.user.profile_picture);
  const email_verified = useSelector((state) => state.user.email_verified);
  const currentEventDetail = useSelector(
    (state) => state.events.currentEventDetail,
  );
  const isMasterTableEnable = useSelector(
    (state) => state.events.masterTableEnable,
  );

  const isAllTableDisable = useSelector(
    (state) => state.events.allTableDisable,
  );

  const [tableList, setTableList] = useState([]);
  const [eventTableUsers, setEventTableUsers] = useState([]);
  const [isLoadingTableList, setLoadingTableList] = useState(true);
  const [popupVisible, setPopupVisible] = useState(false);

  const [popupJoinTableNumber, setPopupJoinTableNumber] = useState(null);
  const [openCreateEvent, setOpenCreateEvent] = useState(false);
  const [eventData, setEventData] = useState(initialEventData);

  const [pastEvents, setPastEvents] = useState([]);
  const [personalEvents, setPersonalEvents] = useState([]);
  const [readOnlyData, setReadOnlyData] = useState(false);
  const [isPremiumUser, setIsPremiumUser] = useState(false);
  const [displaySubscriptionRequestPopup, setDisplaySubscriptionRequestPopup] =
    useState(false);

  const callSchedulefromParent = () => {
    setPopupVisible(!popupVisible);
  };

  useEffect(() => {
    tableOrUserList();
    // getEventData();
  }, []);

  const handleJoinTableConfirmation = (data, event) => {
    console.log(event.target.alt);
    console.log(data);
    if (event.target.alt.indexOf("Table") === -1) return;
    if (data?.room_limit === data?.user_count) {
      toast.error("Room limit reached");
    } else {
      const userList = data?.user_list;
      const userFound =
        userList?.length && userList?.find((u) => u.id === userId);

      if (userFound) {
        toast.error("You already joined the table");
        return;
      }

      setPopupJoinTableNumber(data?.room_slug);
      joinTableConfirmationRef.current.click();
    }
  };

  const handleCloseTableConfirmation = () => {
    joinTableConfirmationClosebtnRef.current.click();
  };

  const handleJoinTable = () => {
    meetingTableRef.current.updateUserCreditDetails(popupJoinTableNumber);
  };

  function distributeUsersIntoGroups(users, roomLimit) {
    const numberOfGroups = 4;
    let distribution = [];

    if (roomLimit === 4) {
      distribution = [1, 1, 1, 1]; // Each group gets 1 user
    } else if (roomLimit === 6) {
      distribution = [2, 1, 2, 1]; // Groups 1 and 3 get 2 users, others get 1
    } else if (roomLimit === 8) {
      distribution = [3, 1, 3, 1]; // Groups 1 and 3 get 3 users, others get 1
    } else {
      const baseUsersPerGroup = Math.floor(roomLimit / numberOfGroups);
      const remainder = roomLimit % numberOfGroups;

      distribution = Array(numberOfGroups).fill(baseUsersPerGroup);

      for (let i = 0; i < remainder; i++) {
        distribution[i % 2 === 0 ? 0 : 2]++;
      }
    }

    const groups = [];
    let userIndex = 0;

    for (let groupIndex = 0; groupIndex < numberOfGroups; groupIndex++) {
      const userCount = distribution[groupIndex];
      const groupUsers = [];

      for (let i = 0; i < userCount && userIndex < users.length; i++) {
        groupUsers.push(users[userIndex]);
        userIndex++;
      }

      groups.push(groupUsers);
    }

    return groups;
  }

  const tableOrUserList = async (roomID) => {
    const configheader = {
      "Content-Type": `application/json`,
    };
    try {
      const response = await axios.get(
        `${clientConfig.siteUrl}wl/v1/rooms-users`,
        { headers: configheader },
      );

      const eventTableUsers = [];
      const otherTableUsers = [];
      response?.data?.forEach((table) => {
        const users = table?.users || [];
        if (table?.room_slug === "event_table") {
          eventTableUsers.push({
            id: table?.id,
            room_title: table?.room_title,
            room_slug: table?.room_slug,
            room_limit: table?.room_limit,
            user_count: users?.length || 0,
            user_list: users || [],
            users: distributeUsersIntoGroups(users, table?.room_limit) || [],
          });
        } else {
          otherTableUsers.push({
            id: table?.id,
            room_title: table?.room_title,
            room_slug: table?.room_slug,
            room_limit: table?.room_limit,
            user_count: users?.length || 0,
            user_list: users || [],
            users: distributeUsersIntoGroups(users, table?.room_limit) || [],
          });
        }
      });
      setTableList(otherTableUsers);
      setEventTableUsers(eventTableUsers);

      console.log({ eventTableUsers });

      // const tables = response?.data?.map((table) => {
      //   const users = table?.users || [];

      //   return {
      //     id: table?.id,
      //     room_title: table?.room_title,
      //     room_slug: table?.room_slug,
      //     room_limit: table?.room_limit,
      //     user_count: users?.length || 0,
      //     user_list: users || [],
      //     users: distributeUsersIntoGroups(users, table?.room_limit) || [],
      //   };
      // });
      // setTableList(tables);
      setLoadingTableList(false);
      // return tables;
      return otherTableUsers;
    } catch (e) {
      toast.error(
        e?.response?.data?.message ||
          "Something went wrong. Please try again later.",
      );
      setLoadingTableList(false);
      return [];
    }
  };

  const handleAdd20CreditBeta = async () => {
    if (parseInt(userCredit) > 100) {
      toast.warning("Max credits reached for current plan.");
      return;
    }

    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Barer ${token}`,
      };
      const response = await axios.post(
        `${clientConfig.siteUrl}wl/v1/add-beta-credits`,
        {
          credit: 20,
          user_id: userId,
        },
        {
          headers,
        },
      );

      if (response.status === 200) {
        dispatch(updateBetaCredit(20));
        toast.success(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const logo = (
    <span style={{ fontWeight: 900, color: "#3761b3", fontStyle: "italic" }}>
      3For3 Networking
    </span>
  );

  const handleOpenCreateEventSubscriptionRequest = () => {
    console.log("Open subscription request");
    setDisplaySubscriptionRequestPopup(true);
  };

  const handleOpenCreateEvent = () => {
    setOpenCreateEvent(true);
  };

  const handleCloseCreateEvent = () => {
    setOpenCreateEvent(false);
    setReadOnlyData(false);
    setEventData(initialEventData);
  };

  const getActiveSubscription = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.post(
        "https://3for3networking.com/backend/wp-content/plugins/wl-api/stripe-payment/get-current-subscription.php",
        {
          userId: userId,
        },
        { headers: headers },
      );
      console.log(response.data);

      if (response.data) {
        const subscription = response.data;
        const activeSubscriptionPlan = subscription.active_plan;
        console.log("Active Subscription Plan: ", activeSubscriptionPlan);
        setIsPremiumUser(activeSubscriptionPlan === "premium_plus");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitCreateEvent = async (e) => {
    e.preventDefault();
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Barer ${token}`,
      };
      const response = await axios.post(
        `${clientConfig.siteUrl}wl/v1/submit-personal-events`,
        {
          topic_name: eventData.event_name,
          topic_description: eventData.topic_description,
          user_id: userId,
          event_date: eventData.event_date,
          event_time: eventData.event_time,
          event_type: eventData.event_type,
          event_invites: eventData.event_invites,
          httpURL: window.location.origin,
        },
        {
          headers,
        },
      );
      console.log("Event submission response: ", response);
      // Reset form and close modal
      setEventData(initialEventData);
      setOpenCreateEvent(false);
      getEventData();
    } catch (error) {
      console.log(error);
    }
    console.log("Event Data Submitted: ", eventData);
  };

  const handleRegisterForEvent = async (event) => {
    console.log("Registering for event: ", event);
    const headers = {
      "Content-Type": "application/json",
    };

    // const response = await axios.post(
    //   `${clientConfig.siteUrl}wl/v1/rsvp`,
    //   {
    //     event_id: event.id,
    //     event_date: `${event.event_date} ${event.event_time}`,
    //     user_id: userId,
    //     user_name: firstName,
    //     user_profile:
    //       profile_picture ||
    //       `https://avatar.iran.liara.run/username?username=${firstName}`,
    //     action_type: actionType,
    //   },
    //   { headers: headers },
    // );
  };

  const handleRedirectToSubscriptionWindow = () => {
    // redirect using react router to /billing
    history.push("/billing");
  }
  const getEventData = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${clientConfig.siteUrl}wl/v1/get-personal-events`,
        {
          headers,
        },
      );
      const events = response.data || [];
      // event_date is "2026-02-11" convert it to date object and compare with current date to separate past and upcoming events
      setPastEvents(events.filter((event) => {
        const eventDate = new Date(event.event_date);
        return eventDate < new Date();
      }));
      setPersonalEvents(
        events.filter((event) => {
          const eventDate = new Date(event.event_date);
          return eventDate >= new Date();
        }),
      );
      console.log("Events data: ", response);
    } catch (error) {
      console.log(error);
    }
  };

  const handleViewEventDetails = (event) => {
    setReadOnlyData(true);
    setOpenCreateEvent(true);
    setEventData({
      event_name: event?.topic_name || "",
      topic_description: event?.topic_description || "",
      event_date: event?.event_date || "",
      event_time: event?.event_time || "",
      event_type: event?.event_type || "public",
      event_invites: event?.event_invites || "",
    });
  };

  useEffect(() => {
    getActiveSubscription();
    getEventData();
  }, []);

  console.log(isPremiumUser)

  return (
    <MainContainer
      callSchedulefromParent={callSchedulefromParent}
      popupVisible={popupVisible}
    >
      <div className="row py-4 px-3">
        <div className="col-12 col-md-6">
          <h1 className="title mb-0">Events</h1>
        </div>
        <div className="col-12 col-md-6 text-md-right">
          {isPremiumUser ? (
            <button
              className="btn btn-primary"
              disabled={false}
              onClick={handleOpenCreateEvent}
            >
              Create Event
            </button>
          ) : (
            <button
              className="btn btn-primary"
              disabled={false}
              onClick={handleOpenCreateEventSubscriptionRequest}
            >
              Create Event
            </button>
          )}
        </div>

        <div className="col-12">
          {/* Upcoming / Live Events */}
          <div className="p-3 border mt-4">
            <p className="font-weight-bold mb-3">Live / Upcoming</p>

            <div className="custom-table-event-list">
              <div className="head-row row">
                <div className="col-12 col-md-1 col-lg-3 font-weight-bold">
                  Event By
                </div>
                <div className="col-12 col-md-5 font-weight-bold">Event</div>
                <div className="col-12 col-md-2 font-weight-bold">
                  Time (EST)
                </div>
                <div className="col-12 col-md-2"></div>
              </div>

              {personalEvents.length > 0 ? (
                personalEvents.map((event, index) => (
                  <div className="body-row row" key={index}>
                    <div className="col-12 col-md-1 col-lg-3 text-left">
                      {event.first_name ? (
                        <div className="text-left">
                          <img
                            src={event.profile_picture_url}
                            alt={event.first_name}
                            className="rounded-circle border border-dark bg-secondary mr-2"
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                            }}
                          />{" "}
                          <small className="text-capitalize">
                            {event.first_name} {event.last_name}
                          </small>
                        </div>
                      ) : (
                        logo
                      )}
                    </div>
                    <div className="col-12 col-md-5">
                      <p className="mb-0">
                        <b>{event?.topic_name}</b>
                      </p>
                      <p className="mb-0">{event?.topic_description}</p>
                    </div>
                    <div className="col-12 col-md-2">
                      {/* // convert date and time to Dec 08 and 2:00 PM format */}
                      <p className="mb-0">
                        {new Date(
                          `${event?.event_date}T${event?.event_time}`,
                        ).toLocaleDateString("en-US", {
                          month: "short",
                          day: "2-digit",
                        })}
                      </p>
                      <p className="mb-0">
                        {new Date(
                          `${event?.event_date}T${event?.event_time}`,
                        ).toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </p>
                    </div>
                    <div className="col-12 col-md-2">
                      <button
                        className="btn btn-link font-weight-bold p-0"
                        onClick={() => handleViewEventDetails(event)}
                        style={{ fontSize: 14 }}
                      >
                        View Details
                      </button>

                      {parseInt(event?.user_id) !== userId &&
                        event.event_date &&
                        new Date(event.event_date) > new Date() && (
                          <button
                            className="btn btn-link font-weight-bold p-0"
                            onClick={() => handleRegisterForEvent(event)}
                            style={{ fontSize: 14, marginLeft: 10 }}
                          >
                            Register
                          </button>
                        )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="body-row row">
                  <div className="col-12 text-center">
                    No events submitted yet.
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Past Events */}
          <div className="p-3 border mt-4">
            <p className="font-weight-bold mb-3">Past</p>

            <div className="custom-table-event-list">
              <div className="head-row row">
                <div className="col-12 col-md-1 col-lg-3 font-weight-bold">
                  Event By
                </div>
                <div className="col-12 col-md-5 font-weight-bold">Event</div>
                <div className="col-12 col-md-2 font-weight-bold">
                  Time (EST)
                </div>
                <div className="col-12 col-md-2"></div>
              </div>

              {pastEvents.length > 0 ? (
                pastEvents.map((event, index) => (
                  <div className="body-row row" key={index}>
                    <div className="col-12 col-md-1 col-lg-3 text-left">
                      {event.first_name ? (
                        <div className="text-left">
                          <img
                            src={event.profile_picture_url}
                            alt={event.first_name}
                            className="rounded-circle border border-dark bg-secondary mr-2"
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                            }}
                          />{" "}
                          <small className="text-capitalize">
                            {event.first_name} {event.last_name}
                          </small>
                        </div>
                      ) : (
                        logo
                      )}
                    </div>
                    <div className="col-12 col-md-5">
                      <p className="mb-0">
                        <b>{event?.topic_name}</b>
                      </p>
                      <p className="mb-0">{event?.topic_description}</p>
                    </div>
                    <div className="col-12 col-md-2">
                      {/* // convert date and time to Dec 08 and 2:00 PM format */}
                      <p className="mb-0">
                        {new Date(
                          `${event?.event_date}T${event?.event_time}`,
                        ).toLocaleDateString("en-US", {
                          month: "short",
                          day: "2-digit",
                        })}
                      </p>
                      <p className="mb-0">
                        {new Date(
                          `${event?.event_date}T${event?.event_time}`,
                        ).toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </p>
                    </div>
                    <div className="col-12 col-md-2">
                      <button
                        className="btn btn-link font-weight-bold p-0"
                        onClick={() => handleViewEventDetails(event)}
                        style={{ fontSize: 14 }}
                      >
                        View Details
                      </button>

                      {parseInt(event?.user_id) !== userId &&
                        event.event_date &&
                        new Date(event.event_date) > new Date() && (
                          <button
                            className="btn btn-link font-weight-bold p-0"
                            onClick={() => handleRegisterForEvent(event)}
                            style={{ fontSize: 14, marginLeft: 10 }}
                          >
                            Register
                          </button>
                        )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="body-row row">
                  <div className="col-12 text-center">
                    No events submitted yet.
                  </div>
                </div>
              )}
            </div>
          </div>

          
        </div>
      </div>
      {/* <div className="text-center pb-5">
        <div className="row mb-5">
          <div className="col-12">
            <CountdownTimer />
            {currentEventDetail && <Attendees userId={userId} />}
          </div>
        </div>

        <Events />

        <div className="row mt-5">
          <div className="col-12">
            {isMasterTableEnable ? (
              <div className="mb-4">
                <h2 className="title">The Table</h2>

                <button
                  type="button"
                  className="btn btn-primary rounded-10 mt-2 px-5"
                  onClick={() =>
                    meetingTableRef.current.handleJoinTable("event_table")
                  }
                >
                  Join the Table
                </button>

                <div className="table-users-list mt-2">
                  {eventTableUsers[0]?.user_list?.length > 0 && (
                    <div className="d-flex align-items-center flex-column align-content-center w-100 mb-3">
                      <div className="d-flex">
                        {eventTableUsers[0]?.user_list.map(
                          (person, index) =>
                            index < 5 && (
                              <img
                                key={index}
                                src={person.avatar}
                                alt={person.name}
                                className="rounded-circle border border-dark bg-secondary"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  objectFit: "cover",
                                  marginLeft: index === 0 ? "0" : "-20px",
                                  zIndex: 10 + index,
                                }}
                              />
                            ),
                        )}
                        {eventTableUsers[0]?.user_list.length > 5 ? (
                          <div
                            className="rounded-circle text-white d-flex justify-content-center align-items-center border border-dark"
                            style={{
                              width: "50px",
                              height: "50px",
                              marginLeft: "-20px",
                              fontSize: "18px",
                              zIndex: 15,
                              background: "#3762b4",
                            }}
                          >
                            {eventTableUsers[0]?.user_list.length - 5}+
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <h2 className="title">Join the Table</h2>
            )}
            {!email_verified ? (
              <div className="welcome-subtitle mb-0 text-danger">
                Verify your email to join.
              </div>
            ) : (
              <>
                <div className="welcome-subtitle mb-0">
                  <strong>10 credits</strong> to join.
                </div>
                <p className="mt-1 mb-0">
                  <span
                    className="btn p-0 btn-link"
                    onClick={handleAdd20CreditBeta}
                  >
                    Welcome to the beta. Get 20 free credits.
                  </span>
                </p>
              </>
            )}
          </div>

          {isLoadingTableList ? (
            <div className="col-12 text-center">Loading...</div>
          ) : (
            <>
              {!isLoadingTableList && (
                <Pusher
                  channel="meeting"
                  event="meeting_updates"
                  onUpdate={tableOrUserList}
                />
              )}

              {tableList.map((table, tableIndex) => (
                <MeetingTable
                  key={tableIndex}
                  tableIndex={tableIndex}
                  data={table}
                  isLoading={isLoadingTableList}
                  ref={meetingTableRef}
                  handleJoinTableConfirmation={handleJoinTableConfirmation}
                  handleCloseTableConfirmation={handleCloseTableConfirmation}
                  tableDisable={isAllTableDisable}
                />
              ))}
            </>
          )}
        </div>

        <div className="row mt-5" id="app_download_sec">
          <div className="col-12 col-lg-6 mx-auto">
            <p>
              <SiJitsi fontSize={"3em"} />
            </p>
            <p className="font-weight-bold" id="info">
              We use Jitsi for the ultimate web chat experience. Download the
              app.
            </p>

            <div className="row justify-content-center" id="logos">
              <div className="col-12 col-sm-6 col-md-4 col-lg-6 my-2 text-lg-right">
                <a
                  href="https://apps.apple.com/us/app/jitsi-meet/id1165103905"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={AppleStore}
                    alt="Apple store"
                    className="img-fluid"
                  />
                </a>
              </div>
              <div className="col-12 col-sm-6 col-md-4 col-lg-6 my-2 text-lg-left">
                <a
                  href="https://play.google.com/store/apps/details?id=org.jitsi.meet&pli=1"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={GooglePlayStore}
                    alt="Google play store"
                    className="img-fluid"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="jointablemodal"
          tabIndex="-1"
          aria-labelledby="jointablemodalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="jointablemodalLabel">
                  Join the Table
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  ref={joinTableConfirmationClosebtnRef}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <button
                  hidden={true}
                  ref={joinTableConfirmationRef}
                  data-toggle="modal"
                  data-target="#jointablemodal"
                ></button>
              </div>
              <div className="modal-body">
                <p className="m-0 text-left">
                  Confirm to join the table. <strong>10 credits</strong> to
                  join.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary rounded-10"
                  onClick={handleJoinTable}
                >
                  Confirm
                </button>
                <button
                  id="jointableClosebtn"
                  type="button"
                  className="btn btn-secondary rounded-10"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <Modal isOpen={openCreateEvent} size={"modal-lg"}>
        <ModalHeader>
          <h5>{readOnlyData ? "View Event" : "Create Event"}</h5>
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={handleCloseCreateEvent}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <form onSubmit={!readOnlyData ? handleSubmitCreateEvent : null}>
          <ModalBody>
            <div className="row align-items-center">
              <div className="col-12 col-md-3">Event Name *</div>
              <div className="col-12 col-md-9">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter event name"
                  required={true}
                  readOnly={readOnlyData}
                  value={eventData.event_name}
                  onChange={(e) =>
                    setEventData({ ...eventData, event_name: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="row mt-3 align-items-center">
              <div className="col-12 col-md-3">Topic Description *</div>
              <div className="col-12 col-md-9">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter topic description"
                  required={true}
                  readOnly={readOnlyData}
                  value={eventData.topic_description}
                  onChange={(e) =>
                    setEventData({
                      ...eventData,
                      topic_description: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="row mt-3 align-items-center">
              <div className="col-12 col-md-3">Date / Time *</div>
              <div className="col-12 col-md-9">
                <div className="row">
                  <div className="col-6">
                    <input
                      type="date"
                      className="form-control"
                      placeholder="Enter event date"
                      required={true}
                      readOnly={readOnlyData}
                      value={eventData.event_date}
                      onChange={(e) =>
                        setEventData({
                          ...eventData,
                          event_date: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-6">
                    <input
                      type="time"
                      className="form-control"
                      placeholder="Enter event time"
                      required={true}
                      readOnly={readOnlyData}
                      value={eventData.event_time}
                      onChange={(e) =>
                        setEventData({
                          ...eventData,
                          event_time: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-3 align-items-center">
              <div className="col-12 col-md-3">Event Type *</div>
              <div className="col-12 col-md-9">
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="eventType"
                    id="publicEvent"
                    value="public"
                    readOnly={readOnlyData}
                    checked={eventData.event_type === "public"}
                    onChange={(e) =>
                      setEventData({
                        ...eventData,
                        event_type: e.target.value,
                      })
                    }
                  />
                  <label className="form-check-label" htmlFor="publicEvent">
                    Public
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="eventType"
                    id="privateEvent"
                    value="private"
                    readOnly={readOnlyData}
                    disabled={true}
                    checked={eventData.event_type === "private"}
                    onChange={(e) =>
                      setEventData({
                        ...eventData,
                        event_type: e.target.value,
                      })
                    }
                  />
                  <label className="form-check-label" htmlFor="privateEvent">
                    Private (Coming Soon)
                  </label>
                </div>
              </div>
            </div>
            {/* <div className="row mt-3 align-items-center">
              <div className="col-12 col-md-3">Invite</div>
              <div className="col-12 col-md-9">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Invite by email (comma separated)"
                  required={false}
                  readOnly={readOnlyData}
                  disabled={true}
                  value={eventData.event_invites}
                  onChange={(e) =>
                    setEventData({
                      ...eventData,
                      event_invites: e.target.value,
                    })
                  }
                />
              </div>
            </div> */}
          </ModalBody>
          <ModalFooter>
            {!readOnlyData && (
              <button
                type="submit"
                className="btn btn-primary rounded-10 px-4"
                disabled={
                  !(
                    eventData.event_name &&
                    eventData.topic_description &&
                    eventData.event_date &&
                    eventData.event_time
                  )
                }
              >
                Submit
              </button>
            )}
            <button
              id="meetingcomplete_close_btn"
              type="button"
              className="btn btn-outline-secondary rounded-10 px-4"
              onClick={handleCloseCreateEvent}
            >
              Cancel
            </button>
          </ModalFooter>
        </form>
      </Modal>
      {/* displaySubscriptionRequestPopup */}

      <Modal isOpen={displaySubscriptionRequestPopup}>
        <ModalHeader>
          <h5>Upgrade to Premium Plus</h5>
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={() => setDisplaySubscriptionRequestPopup(false)}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>

        <ModalBody>
          <div className="row align-items-center">
            <div className="col-12">
              <p>
                Creating events is a premium feature. Upgrade to Premium Plus to
                create and host your own events.
              </p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-primary rounded-10 px-4"
            onClick={handleRedirectToSubscriptionWindow}
          >
            Upgrade
          </button>

          <button
            id="meetingcomplete_close_btn"
            type="button"
            className="btn btn-outline-secondary rounded-10 px-4"
            onClick={() => setDisplaySubscriptionRequestPopup(false)}
          >
            Cancel
          </button>
        </ModalFooter>
      </Modal>
    </MainContainer>
  );
}

export default EventListing;
